// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"UploadFileLog_stickyHeader_38b_6","q-table__top":"UploadFileLog_q-table__top_30FzG","q-table__bottom":"UploadFileLog_q-table__bottom_3fsJb"};